import { useRef, useState } from "react";

function VideoPlayer() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true); // hide overlay
    }
  };

  return (
    <div>
      <video
        ref={videoRef}
        className="absolute w-full h-full object-cover z-10"
        src={require("../media/videos/Eloquent-i_Promo_Animation.mp4")}
        controls
      />

      {!isPlaying && (
        <button
          onClick={handlePlay}
          className="absolute inset-0 flex items-center justify-center z-20 transition-transform duration-300 hover:scale-105 bg-[#6712FF]/10"
        >
          <div className="relative flex items-center justify-center">
            {/* Outer border */}
            <div className="absolute w-52 h-52 rounded-full bg-[#6912ff4f]"></div>

            {/* Blurred purple circle */}
            <div className="absolute w-36 h-36 bg-[#6712FF] rounded-full blur-[2px]"></div>

            {/* Solid purple circle for icon */}
            <div className="relative w-52 h-52 flex items-center justify-center">
              <img src={require("../media/images/play.png")} alt="Play" className="w-10 h-10 z-10 ml-2" />
            </div>
          </div>
        </button>
      )}
    </div>
  );
}

export default VideoPlayer;
